module.exports = __webpack_public_path__ + "media/images/foal-3dd09fcc1cbb5df0267c4a63e2768132.jpg";